query allMarketParameters(
  $filter: MarketParameterFilter,
  ) {
  allMarketParameters(
    filter: $filter
  ) {
    nodes {
      name
      code
      sport
    }
  }
}
